<template>
  <v-layout justify-end>
    <v-btn outline slot="activator" color="primary" class="mb-2" @click="open">
      <v-icon dark left>note_add</v-icon>New Item
    </v-btn>
    <v-dialog v-model="localDialog" persistent max-width="1000px" scrollable>
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container fluid>
            <v-form ref="form">
              <v-layout row wrap>
                <v-flex>
                  <image-uploader
                    v-bind:constImage="local.image"
                    v-bind:dialog="dialog"
                    v-bind:errorMsg="errorMsg"
                    @image="assignImage">
                  </image-uploader>

                  <v-text-field
                    label="Name"
                    v-model="local.name"
                    :rules="generalRules"
                    required>
                  </v-text-field>

                  <v-select
                    :items="Animation"
                    :item-text="item => Animation.name"
                    :item-value="item=> Animation.id"
                    v-model="local.typeOfAnimation"
                    label="Type of Animation"
                    chips
                    persistent-hint>
                  </v-select>

                  <v-text-field
                    label="Genre"
                    v-model="local.genre"
                  >
                  </v-text-field>

                  <v-text-field
                    label="Trim"
                    v-model="local.trim"
                  >
                  </v-text-field>
                  <v-text-field
                    label="Blend"
                    v-model="local.blend"
                  >
                  </v-text-field>
                  <v-text-field
                    label="Stich"
                    v-model="local.stich"
                  >
                  </v-text-field>
                  <h3>Attachments</h3>
                  <file-uploader
                    @input="assignFBX"
                    v-model="local.fbx">
                    <div slot="activator">
                      <v-text-field
                        label="Filmbox"
                        v-model="local.fbx.fileName"
                        readonly prepend-icon="attach_file"
                        :rules="generalRules"
                        required>
                      </v-text-field>
                    </div>
                  </file-uploader>
                  <file-uploader
                    @input="assignIOS"
                    v-model="local.asset_bundle.iOS">
                    <div slot="activator">
                      <v-text-field
                        label="iOS Asset Bundle"
                        v-model="local.asset_bundle.iOS.fileName"
                        readonly prepend-icon="attach_file"
                        :rules="generalRules"
                        required>
                      </v-text-field>
                    </div>
                  </file-uploader>
                  <file-uploader
                    @input="assignAndroid"
                    v-model="local.asset_bundle.Android">
                    <div slot="activator">
                      <v-text-field
                        label="Android Asset Bundle"
                        v-model="local.asset_bundle.Android.fileName"
                        readonly prepend-icon="attach_file"
                        :rules="generalRules"
                        required>
                      </v-text-field>
                    </div>
                  </file-uploader>
                  <file-uploader
                    @input="assignWebGL"
                    v-model="local.asset_bundle.WebGL">
                    <div slot="activator">
                      <v-text-field
                        label="WebGL Asset Bundle"
                        v-model="local.asset_bundle.WebGL.fileName"
                        readonly prepend-icon="attach_file"
                        :rules="generalRules"
                        required>
                      </v-text-field>
                    </div>
                  </file-uploader>
                  <br>
                  <h3>Type of Rigs</h3>
                  <v-radio-group v-model="local.rig">
                    <v-radio :label="rigTypes.humanoid" :value="rigTypes.humanoid"></v-radio>
                    <v-radio :label="rigTypes.custom" :value="rigTypes.custom"></v-radio>
                  </v-radio-group>
                  <br>
                </v-flex>
                <v-spacer></v-spacer>
                <v-divider vertical></v-divider>
                <v-spacer></v-spacer>
                <v-flex>
                  <div v-if="local.type === 'Character'">
                    <h3>Spectrum from Mixamo</h3>
                  </div>
                  <v-select
                    v-if="local.type === 'Character'"
                    :items="Spectrum"
                    :item-text="item => Spectrum.name"
                    :item-value="item=> Spectrum.id"
                    v-model="local.spectrum"
                    label="Select spectrum"
                    chips
                    persistent-hint>
                  </v-select>
                  <h3>Joints</h3>
                  <v-text-field
                    label="Interactive Joint"
                    v-model="local.joint"
                  >
                  </v-text-field>
                  <br>
                  <p>Dimension in meters</p>
                  <v-layout>
                    <v-text-field
                      v-model="local.dimension.X"
                      label="Dimension X"
                      type="number">
                    </v-text-field>
                    <v-text-field
                      v-model="local.dimension.Y"
                      label="Dimension Y"
                      type="number">
                    </v-text-field>
                    <v-text-field
                      v-model="local.dimension.Z"
                      label="Dimension Z"
                      type="number">
                    </v-text-field>
                  </v-layout>

                  <v-select
                    :items="Rotation"
                    :item-text="item => Rotation.name"
                    :item-value="item=> Rotation.id"
                    v-model="local.rotation"
                    label="Select rotation"
                    chips
                    persistent-hint>
                  </v-select>
                  <v-text-field
                    v-model="local.numberOfLoops"
                    label="Number Of Loops"
                    type="number">
                  </v-text-field>
                  <v-text-field
                    v-model="local.duration"
                    label="Duration (sec)"
                    type="number">
                  </v-text-field>
                  <v-select
                    :items="inverse_kinematics"
                    :item-text="item => inverse_kinematics.name"
                    :item-value="item=> inverse_kinematics.id"
                    v-model="local.inverseKinematics"
                    label="Select Inverse Kinematics"
                    chips
                    persistent-hint>
                  </v-select>
                  <h3>Position of Origin</h3>
                  <v-layout>
                    <v-text-field
                      v-model="local.positionOfOrigin.X"
                      label="Dimension X"
                      type="number">
                    </v-text-field>
                    <v-text-field
                      v-model="local.positionOfOrigin.Y"
                      label="Dimension Y"
                      type="number">
                    </v-text-field>
                    <v-text-field
                      v-model="local.positionOfOrigin.Z"
                      label="Dimension Z"
                      type="number">
                    </v-text-field>
                  </v-layout>
                  <br>
                  <h3>Rotation of Origin</h3>
                  <v-layout>
                    <v-text-field
                      v-model="local.rotationOfOrigin.X"
                      label="Dimension X"
                      type="number">
                    </v-text-field>
                    <v-text-field
                      v-model="local.rotationOfOrigin.Y"
                      label="Dimension Y"
                      type="number">
                    </v-text-field>
                    <v-text-field
                      v-model="local.rotationOfOrigin.Z"
                      label="Dimension Z"
                      type="number">
                    </v-text-field>
                  </v-layout>
                  <br>
                </v-flex>
              </v-layout>
            </v-form>
<!--            <v-layout align-space-around justify-center column>-->
<!--              <v-form ref="form" v-model="valid" lazy-validation>-->
<!--                <image-uploader-->
<!--                  v-bind:constImage="local.image"-->
<!--                  v-bind:dialog="dialog"-->
<!--                  @image="assignImage">-->
<!--                </image-uploader>-->
<!--                <v-text-field-->
<!--                  label="Name"-->
<!--                  v-model="local.name">-->
<!--                </v-text-field>-->
<!--                <v-text-field-->
<!--                  label="File Name"-->
<!--                  v-model="local.filename">-->
<!--                </v-text-field>-->
<!--                <v-textarea-->
<!--                  label="Description"-->
<!--                  v-model="local.description">-->
<!--                </v-textarea>-->
<!--                <v-text-field-->
<!--                  label="Duration"-->
<!--                  v-model="local.duration">-->
<!--                </v-text-field>-->
<!--                <v-text-field-->
<!--                  label="Service"-->
<!--                  v-model="local.service">-->
<!--                </v-text-field>-->
<!--              </v-form>-->
<!--            </v-layout>-->
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outline @click="close">Cancel</v-btn>
          <v-btn v-if="showSaveButton" color="primary" @click="save">
            <v-flex v-if="this.saving">
              <v-progress-circular
                indeterminate
                color="primary">
              </v-progress-circular>
            </v-flex>
            <v-flex v-else>Save</v-flex>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import ImageUploader from '../uploader/imageUploader'
import FileUploader from '../uploader/fileUploader'
export default {
  name: 'addPropAnimation',
  components: {ImageUploader, FileUploader},
  data: () => ({
    valid: true,
    errorMsg: '',
    animations: [],
    sounds: [],
    saving: false,
    rigTypes: {
      humanoid: 'Humanoid',
      custom: 'Custom'
    },
    generalRules: [
      v => !!v || 'This field is required'
    ],
    Animation: ['Idle', 'Moving'],
    Rotation: ['Inwards', 'Outwards'],
    Spectrum: ['Energy', 'Posture'],
    inverse_kinematics: [],
    local: {
      id: null,
      type: 'Character',
      image: null,
      name: '',
      typeOfAnimation: '',
      rig: 'Humanoid',
      genre: [],
      joint: [],
      dimension: {
        X: 0,
        Y: 0,
        Z: 0
      },
      rotation: '',
      spectrum: '',
      fbx: {
        fileName: '',
        file: '',
        fileURL: ''
      },
      asset_bundle: {
        iOS: {
          fileName: '',
          file: '',
          fileURL: ''
        },
        Android: {
          fileName: '',
          file: '',
          fileURL: ''
        },
        WebGL: {
          fileName: '',
          file: '',
          fileURL: ''
        }
      },
      numberOfLoops: 0,
      duration: 0,
      trim: '',
      blend: '',
      stich: '',
      inverseKinematics: '',
      positionOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      rotationOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      }
    }
  }),
  props: {
    dialog: '',
    editedID: '',
    showSaveButton: true,
    info: {
      id: null,
      name: '',
      filename: '',
      service: '',
      description: '',
      image: null
    }
  },
  computed: {
    formTitle () {
      return this.editedID === -1 ? 'New Character Animation' : this.showSaveButton ? 'Edit Character Animation' : 'Preview Character Animation'
    },
    localDialog: {
      get: function () {
        return this.dialog
      }
    }
  },
  watch: {
    info (val) {
      this.local = Object.assign({}, val)
    },
    dialog (val) {
      if (!val) {
        this.saving = false
      }
    }
  },
  methods: {
    assignImage (val) {
      this.local.image = val
    },
    assignFBX (payload) {
      this.local.fbx = payload
    },
    assignIOS (payload) {
      this.local.asset_bundle.iOS = payload
    },
    assignAndroid (payload) {
      this.local.asset_bundle.Android = payload
    },
    assignWebGL (payload) {
      this.local.asset_bundle.WebGL = payload
    },
    open () {
      this.$emit('open')
    },
    close () {
      this.$emit('close')
    },
    validateForm () {
      let flag = this.$refs.form.validate()
      if (this.local.image === null) {
        flag = false
        this.errorMsg = 'Please add a picture'
      }
      return flag
    },
    save () {
      if (this.validateForm()) {
        this.saving = true
        this.$emit('save', this.local)
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/assets/add-new/addCharacterAnimation.vue